import Auth from '../models/Auth'
import axios from 'axios'
import { NO_ACCESS_PORTAL_CODE } from '../constants/permissions'
import { loadingOverlayService } from '../App/layout/Indicator/loading-overlay-service';
import { toast } from 'react-toastify';

// Gloable config
axios.interceptors.request.use(request => {
    if (!request.skipLoadingOverlay) {
        loadingOverlayService.put(`${request.method} : ${request.url}`)
    }
    return request;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    if (!response?.config?.skipLoadingOverlay) {
        loadingOverlayService.pop()
    }
    // Edit response config
    return response;
}, error => {
    console.log('Error', error)
    if (!error?.config?.skipLoadingOverlay) {
        loadingOverlayService.pop()
    }
    const { response } = error;
    let errorMsg = (response && response.data && response.data.error) || (response && response.data) || response || {}
    let statusText = response && response.statusText
    let message = errorMsg.message || statusText
    let status = response && response.status
    console.log('Error Text', status, message, statusText)
    errorMsg = {
        status,
        statusText,
        ...errorMsg,
        response,
    }
    // toast.error(`${message}`)
    return Promise.reject(errorMsg);
});
class AxiosHelper {
    static _axios = null
    static _unauthorizedSubscribers = []
    static _unauthorizedTrozedSubscribers = []
    static _alertTimer = null
    static _myalert(msg, callback) {
        if (this._alertTimer) clearTimeout(this._alertTimer)
        this._alertTimer = setTimeout(() => {
            msg && toast.error(`${msg}`)
            callback && callback()
        }, 300)
    }

    static getInstance() {
        if (!this._axios)
            this._axios = this._inst()
        return this._axios
    }

    static unauthorizedAccess() {
        this._unauthorizedSubscribers.forEach(fn => {
            if (fn instanceof Function) {
                fn.call()
            }
        })
    }
    static unauthorizedTrozenAccess() {
        this._unauthorizedTrozedSubscribers.forEach(fn => {
            if (fn instanceof Function) {
                fn.call()
            }
        })
    }

    static subscribeUnauthorizedAccess(fn) {
        this._unauthorizedSubscribers.push(fn)
        return fn
    }

    static unsubscribeUnauthorizedAccess(fn) {
        const index = this._unauthorizedSubscribers.findIndex(f => f === fn)
        if (index !== -1) {
            this._unauthorizedSubscribers.splice(index, 1);
        }
    }

    static subscribeUnauthorizedTrozenAccess(fn) {
        this._unauthorizedTrozedSubscribers.push(fn)
        return fn
    }
    static unsubscribeUnauthorizedTrozenAccess(fn) {
        const index = this._unauthorizedTrozedSubscribers.findIndex(f => f === fn)
        if (index !== -1) {
            this._unauthorizedTrozedSubscribers.splice(index, 1);
        }
    }

    static _reqHeadersSet(request) {
        if (Auth.token) {
            request.headers['Authorization'] = `Bearer ${Auth.token}`
        }
        if (Auth.userId) {
            request.headers['x-userId'] = Auth.userId
        }
        if (Auth.portalId) {
            request.headers['x-portal'] = Auth.portalId
        }
    }

    static async _extractErrorMessage(response) {
        const data = response?.data
        if (!data) {
            return null
        }

        if (typeof data === 'object' && !(data instanceof Blob) && !(data instanceof ArrayBuffer)) {
            return data.message || data.error?.message || null
        }

        try {
            let text
            if (data instanceof Blob) {
                text = await data.text()
            } else if (typeof data === 'string') {
                text = data
            } else if (data instanceof ArrayBuffer) {
                text = new TextDecoder().decode(data)
            } else {
                return null
            }
            const parsed = JSON.parse(text)
            return parsed?.message || parsed?.error?.message || null
        } catch (e) {
            return null
        }
    }

    static _inst() {
        let _axios = axios.create({
            headers: {
                'Authorization': '',
                'x-userId': '',
                'x-portal': ''
            }
        })
        _axios.interceptors.request.use((request) => {
            this._reqHeadersSet(request)
            if (!request.skipLoadingOverlay) {
                loadingOverlayService.put(`${request.method} : ${request.url}`)
            }

            return request
        }, error => {
            // loadingOverlayService.put(error)
            return error
        })
        _axios.interceptors.response.use((response) => {
            if (!response?.config?.skipLoadingOverlay) {
                loadingOverlayService.pop()
            }
            return response
        }, async (error) => {
            console.log('Error', error)
            if (!error?.config?.skipLoadingOverlay) {
                loadingOverlayService.pop()
            }
            const { response, config } = error;
            const status = response?.status
            const statusText = response?.statusText || ''
            let errorMsg = (response && response.data && response.data.error) || (response && response.data) || response || {}
            const parsedMessage = config?.skipGlobalErrorToast
                ? null
                : await this._extractErrorMessage(response)
            let code = (typeof errorMsg === 'object' && !(errorMsg instanceof Blob) && errorMsg.code) || statusText
            let message = parsedMessage || (typeof errorMsg === 'object' && !(errorMsg instanceof Blob) && errorMsg.message) || statusText

            console.log('Error Text', status, code, message, statusText)
            errorMsg = {
                status,
                statusText,
                message,
                code,
                response,
            }

            if (status === 401) {
                if (message && (message.indexOf('jwt expired') >= 0 || message.indexOf('is invalidated') >= 0)) {
                    errorMsg.message = 'Your current session is expired. Please log-in again!'
                    this._myalert(errorMsg.message, () => {
                        this.unauthorizedAccess();
                    })
                } else if (code === 'LOGIN-ACCOUNT-INACTIVE' || code === 'LOGIN-ACCOUNT-NOT-VERIFIED') {
                    errorMsg.message = message || 'The Account is not active'
                    this._myalert(errorMsg.message, () => {
                        this.unauthorizedAccess();
                    })
                } else {
                    this._myalert('', () => {
                        this.unauthorizedAccess();
                    })
                }
                throw errorMsg
            }
            if (status >= 400) {
                if (response.data && response.data.error) {
                    if (response.data.error.portalCode === NO_ACCESS_PORTAL_CODE) {
                        this.unauthorizedTrozenAccess()
                    }
                }
            }
            if (!config?.skipGlobalErrorToast) {
                toast.error(`${message}`)
            }
            throw errorMsg
        })
        return _axios
    }
}

export default AxiosHelper